
















































import { ChildListElement } from '@/services/masterdata';

export default {
    props: {
        paymentValue: String,
        termsValue: String,
        paymentNoteValue: String,
        validate: Boolean,
        formstyle: Object,
        lists: Object,
    },
    watch: {
        validate(this: any, newVal: any, oldVal: any) {
            this.checkAndEmit();
        },
    },
    data(this: any): any {
        return {
            rules: {
                Payment: [
                    { required: true, message: this.$t('masterDataFromRules.RequiredSelect'), trigger: null },
                ],
                Terms: [
                    { required: true, message: this.$t('masterDataFromRules.RequiredSelect'), trigger: null },
                ],
            },
            form: {
                Payment: '',
                Terms: '',
                PaymentNote: '',
            },
        };
    },
    computed: {
        computeTerms(this: any) {
            const list = this.lists.Terms.filter((i: ChildListElement) => i.ParentCode === this.form.Payment);
            return list;
        },
        computePayment: {
            get(this: any) {
                return this.form.Payment;
            },
            set(this: any, newValue: String) {
                this.$emit('payment', newValue);
                this.form.Payment = newValue;
            },
        },
    },
    methods: {
        reset(this: any) {
            this.$emit('reset');
        },
        checkTerms(this: any) {
            if (this.computeTerms.filter((i: ChildListElement) => i.Codice === this.form.Terms).length === 0) {
                this.form.Terms = undefined;
            }
            this.reset();
        },
        async checkAndEmit(this: any) {
            this.$emit('payment', this.form.Payment);
            this.$emit('terms', this.form.Terms);
            this.$emit('paymentNote', this.form.PaymentNote);
            this.$refs.form.validate((val: any) => {
                if (val) {
                    this.$emit('ok');
                }
            });
        },
    },
    beforeMount(this: any) {
        this.form.Payment = this.paymentValue;
        this.form.Terms = this.termsValue;
        this.form.PaymentNote = this.paymentNoteValue;
    },
};
